import React from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import InputField from 'components/LoginForm/Input';
import countries from '../Register/registerCountriesData';
import states from '../Register/registerStatesData';

const RegisterTrade = (props) => (
  <div className="Register">
    <InputField
      defaultVal={props.defaultVal}
      change={props.change}
      fieldType="email"
      fieldName="reg_email"
      fieldPlaceholder="Email"
      icon="at"
    />

    <InputField
      change={props.change}
      fieldType="password"
      fieldName="reg_password"
      fieldPlaceholder={i18n.translate('loginScreen.fields.password')}
      icon="key"
      line
    />

    <InputField
      change={props.change}
      fieldType="password"
      fieldName="reg_passwordConfirm"
      fieldPlaceholder={i18n.translate('loginScreen.fields.passwordConfirm')}
      icon="key"
      line
    />

    <div className="step">Step 3: Complete your profile.</div>
    <h1 style={{ color: props.individualShowData ? props.individualShowData.primary_color : '' }}>
      <b>Tell Us About Yourself</b>
    </h1>
    <hr
      className="short"
      style={{
        backgroundColor: props.individualShowData ? props.individualShowData.primary_color : '',
      }}
    />

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_agency_name"
      fieldPlaceholder="Agency Name"
      icon="home"
    />

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_first_name"
      fieldPlaceholder={i18n.translate('loginScreen.fields.firstName')}
      icon="user"
    />

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_last_name"
      fieldPlaceholder={i18n.translate('loginScreen.fields.lastName')}
      icon="user"
    />

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_title"
      fieldPlaceholder="Title"
      icon="user"
    />

    <p htmlFor="reg_country" className="reg_country">
      {i18n.translate('loginScreen.fields.country')} *
    </p>
    <select id="reg_country" name="reg_country" onChange={props.change} value={props.reg_country}>
      <option value="" disabled selected>
        {i18n.translate('loginScreen.fields.select')}
      </option>
      {countries.map((c, index) => {
        const key = index;
        return (
          <option key={key} value={c.code}>
            {c.name}
          </option>
        );
      })}
    </select>

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_city"
      fieldPlaceholder={i18n.translate('loginScreen.fields.city')}
      icon="user"
    />

    {props.country !== 'US' && (
      <InputField
        change={props.change}
        fieldType="text"
        fieldName="reg_state"
        fieldPlaceholder={i18n.translate('loginScreen.fields.stateProvince')}
        icon="map"
        line
        defaultVal={props.reg_state}
        required
      />
    )}

    {props.country === 'US' && (
      <React.Fragment>
        <p htmlFor="reg_state" className="reg_state">
          {i18n.translate('loginScreen.fields.stateProvince')} *
        </p>
        <select id="reg_state" name="reg_state" onChange={props.change} value={props.state}>
          <option value="" disabled selected>
            {i18n.translate('loginScreen.fields.select')}
          </option>
          {states.map((c, index) => {
            const key = index;
            return (
              <option key={key} value={c.value}>
                {c.label}
              </option>
            );
          })}
        </select>
      </React.Fragment>
    )}

    <InputField
      defaultVal={props.defaultVal}
      change={props.change}
      fieldType="text"
      fieldName="reg_zip_code"
      fieldPlaceholder={i18n.translate('loginScreen.fields.zipCode')}
      icon="map"
    />

    <InputField
      defaultVal={props.defaultVal}
      change={props.change}
      fieldType="tel"
      fieldName="reg_phone_number"
      fieldPlaceholder={i18n.translate('loginScreen.fields.phone')}
      icon="phone"
    />

    <h1 style={{ color: props.individualShowData ? props.individualShowData.primary_color : '' }}>
      <b>Describe Your Business</b>
    </h1>
    <hr
      className="short"
      style={{
        backgroundColor: props.individualShowData ? props.individualShowData.primary_color : '',
      }}
    />

    <p htmlFor="reg_agency_business">What best describes you and your agency’s business?</p>
    <select id="reg_agency_business" name="reg_agency_business" onChange={props.change}>
      <option value="" disabled>
        Please select an option below
      </option>
      <option value="Retail Store Front">Retail Store Front</option>
      <option value="Home-Based Agent">Home-Based Agent</option>
      <option value="Independent Contractor">Independent Contractor</option>
      <option value="Host Agency">Host Agency</option>
      <option value="Call Center or Web-Based Agency">Call Center or Web-Based Agency</option>
      <option value="Inplant or Corporate Travel Department">
        Inplant or Corporate Travel Department
      </option>
      <option value="Other">Other</option>
      <option value="Not Applicable">Not Applicable</option>
    </select>

    <p htmlFor="reg_agency_affiliation">What is Your Main Affiliation?</p>
    <select id="reg_agency_affiliation" name="reg_agency_affiliation" onChange={props.change}>
      <option value="" disabled selected>
        Please select an option below
      </option>
      <option value="AAA">AAA</option>
      <option value="ABC Global Services">ABC Global Services</option>
      <option value="American Express">American Express</option>
      <option value="BCD Travel">BCD Travel</option>
      <option value="Booking Services International (BSI)">
        Booking Services International (BSI)
      </option>
      <option value="CAA">CAA</option>
      <option value="Carlson Wagonlit Travel">Carlson Wagonlit Travel</option>
      <option value="CCRA">CCRA</option>
      <option value="Custom Travel Systems">Custom Travel Systems</option>
      <option value="DER">DER</option>
      <option value="EhotelAG">EhotelAG</option>
      <option value="Ensemble Travel">Ensemble Travel</option>
      <option value="Global Services">Global Services</option>
      <option value="GSM">GSM</option>
      <option value="Guide of Business Travel">Guide of Business Travel</option>
      <option value="Hickory Global Partners">Hickory Global Partners</option>
      <option value="HRG">HRG</option>
      <option value="International Airline Passenger Association (IAPA)">
        International Airline Passenger Association (IAPA)
      </option>
      <option value="International Travel Partners ITP">International Travel Partners ITP</option>
      <option value="Japan Travel Bureau">Japan Travel Bureau</option>
      <option value="Leisure Travel Alliance">Leisure Travel Alliance</option>
      <option value="Liberty Travel">Liberty Travel</option>
      <option value="MAST">MAST</option>
      <option value="RADIUS">RADIUS</option>
      <option value="Rovia">Rovia</option>
      <option value="Sato Travel">Sato Travel</option>
      <option value="Signature">Signature</option>
      <option value="THOR">THOR</option>
      <option value="Travel Club 360">Travel Club 360</option>
      <option value="Travel Leaders Network">Travel Leaders Network</option>
      <option value="Travelgraphic International">Travelgraphic International</option>
      <option value="Traveller Made">Traveller Made</option>
      <option value="TRAVELSAVERS">TRAVELSAVERS</option>
      <option value="Travelsavers/Nest/Affluent Traveler Collection">
        Travelsavers/Nest/Affluent Traveler Collection
      </option>
      <option value="Uniglobe">Uniglobe</option>
      <option value="Virtuoso">Virtuoso</option>
      <option value="WESTA">WESTA</option>
      <option value=" Worldwide Independent Travel Network (WIN)">
        {' '}
        Worldwide Independent Travel Network (WIN)
      </option>
      <option value="None">None</option>
      <option value="Other">Other</option>
      <option value="Not Applicable">Not Applicable</option>
    </select>

    <p htmlFor="reg_id_type" className="spacer">
      What I.D # do you typically use?
    </p>
    <select id="reg_id_type" name="reg_id_type" onChange={props.change}>
      <option value="" disabled selected>
        Please select an option below
      </option>
      <option value="ARC/IATA">ARC/IATA</option>
      <option value="CLIA">CLIA</option>
      <option value="TRUE">TRUE</option>
      <option value="Other">Other</option>
      <option value="Not Applicable">Not Applicable</option>
    </select>

    <p htmlFor="reg_id_type" className="spacer">
      I.D Number
    </p>
    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_id_number"
      fieldPlaceholder="ID Number"
      icon="building"
    />

    <h1 style={{ color: props.individualShowData ? props.individualShowData.primary_color : '' }}>
      <b>What type of travel do you sell?</b>
    </h1>
    <hr
      className="short"
      style={{
        backgroundColor: props.individualShowData ? props.individualShowData.primary_color : '',
      }}
    />

    <p htmlFor="reg_travel_type_1">What is the #1 type of travel you sell?</p>
    <select id="reg_travel_type_1" name="reg_travel_type_1" onChange={props.change}>
      <option value="" disabled selected>
        Please select an option below
      </option>
      <option value="Adventure/Soft Adventure/Expedition">
        Adventure/Soft Adventure/Expedition
      </option>
      <option value="All-Inclusive">All-Inclusive</option>
      <option value="Business Travel">Business Travel</option>
      <option value="Cultural/Experiential Travel">Cultural/Experiential Travel</option>
      <option value="Cruise Ocean">Cruise Ocean</option>
      <option value="Cruise River">Cruise River</option>
      <option value="Diving">Diving</option>
      <option value="Escorted Vacations">Escorted Vacations</option>
      <option value="Family/Multi-Generational Vacations">
        Family/Multi-Generational Vacations
      </option>
      <option value="Golf">Golf</option>
      <option value="Group Vacations">Group Vacations</option>
      <option value="Honeymoon/Wedding/Romantic">Honeymoon/Wedding/Romantic</option>
      <option value="Independent Travel">Independent Travel</option>
      <option value="Luxury">Luxury</option>
      <option value="Rail Travel">Rail Travel</option>
      <option value="Religious/Faith Travel">Religious/Faith Travel</option>
      <option value="Ski Vacations">Ski Vacations</option>
      <option value="Vacation Rentals">Vacation Rentals</option>
      <option value="Wellness/Health/Spa">Wellness/Health/Spa</option>
      <option value="Other">Other</option>
    </select>

    <p htmlFor="reg_travel_type_2">What is the #2 type of travel you sell?</p>
    <select id="reg_travel_type_2" name="reg_travel_type_2" onChange={props.change}>
      <option value="" disabled selected>
        Please select an option below
      </option>
      <option value="Adventure/Soft Adventure/Expedition">
        Adventure/Soft Adventure/Expedition
      </option>
      <option value="All-Inclusive">All-Inclusive</option>
      <option value="Business Travel">Business Travel</option>
      <option value="Cultural/Experiential Travel">Cultural/Experiential Travel</option>
      <option value="Cruise Ocean">Cruise Ocean</option>
      <option value="Cruise River">Cruise River</option>
      <option value="Diving">Diving</option>
      <option value="Escorted Vacations">Escorted Vacations</option>
      <option value="Family/Multi-Generational Vacations">
        Family/Multi-Generational Vacations
      </option>
      <option value="Golf">Golf</option>
      <option value="Group Vacations">Group Vacations</option>
      <option value="Honeymoon/Wedding/Romantic">Honeymoon/Wedding/Romantic</option>
      <option value="Independent Travel">Independent Travel</option>
      <option value="Luxury">Luxury</option>
      <option value="Rail Travel">Rail Travel</option>
      <option value="Religious/Faith Travel">Religious/Faith Travel</option>
      <option value="Ski Vacations">Ski Vacations</option>
      <option value="Vacation Rentals">Vacation Rentals</option>
      <option value="Wellness/Health/Spa">Wellness/Health/Spa</option>
      <option value="Other">Other</option>
    </select>

    <p htmlFor="reg_travel_type_3">What is the #3 type of travel you sell?</p>
    <select id="reg_travel_type_3" name="reg_travel_type_3" onChange={props.change}>
      <option value="" disabled selected>
        Please select an option below
      </option>
      <option value="Adventure/Soft Adventure/Expedition">
        Adventure/Soft Adventure/Expedition
      </option>
      <option value="All-Inclusive">All-Inclusive</option>
      <option value="Business Travel">Business Travel</option>
      <option value="Cultural/Experiential Travel">Cultural/Experiential Travel</option>
      <option value="Cruise Ocean">Cruise Ocean</option>
      <option value="Cruise River">Cruise River</option>
      <option value="Diving">Diving</option>
      <option value="Escorted Vacations">Escorted Vacations</option>
      <option value="Family/Multi-Generational Vacations">
        Family/Multi-Generational Vacations
      </option>
      <option value="Golf">Golf</option>
      <option value="Group Vacations">Group Vacations</option>
      <option value="Honeymoon/Wedding/Romantic">Honeymoon/Wedding/Romantic</option>
      <option value="Independent Travel">Independent Travel</option>
      <option value="Luxury">Luxury</option>
      <option value="Rail Travel">Rail Travel</option>
      <option value="Religious/Faith Travel">Religious/Faith Travel</option>
      <option value="Ski Vacations">Ski Vacations</option>
      <option value="Vacation Rentals">Vacation Rentals</option>
      <option value="Wellness/Health/Spa">Wellness/Health/Spa</option>
      <option value="Other">Other</option>
    </select>

    <p htmlFor="reg_destination_1">What’s the #1 destination/region you sell?</p>
    <select id="reg_destination_1" name="reg_destination_1" onChange={props.change}>
      <option value="" disabled selected>
        Please select an option below
      </option>
      <option value="USA/Canada">USA/Canada</option>
      <option value="Mexico">Mexico</option>
      <option value="Caribbean">Caribbean</option>
      <option value="Central/South America/Antarctica">Central/South America/Antarctica</option>
      <option value="Europe">Europe</option>
      <option value="Africa/Middle East">Africa/Middle East</option>
      <option value="Asia">Asia</option>
      <option value="Australia/New Zealand/South Pacific">
        Australia/New Zealand/South Pacific
      </option>
    </select>

    <p htmlFor="reg_destination_2">What’s the #2 destination/region you sell?</p>
    <select id="reg_destination_2" name="reg_destination_2" onChange={props.change}>
      <option value="" disabled selected>
        Please select an option below
      </option>
      <option value="USA/Canada">USA/Canada</option>
      <option value="Mexico">Mexico</option>
      <option value="Caribbean">Caribbean</option>
      <option value="Central/South America/Antarctica">Central/South America/Antarctica</option>
      <option value="Europe">Europe</option>
      <option value="Africa/Middle East">Africa/Middle East</option>
      <option value="Asia">Asia</option>
      <option value="Australia/New Zealand/South Pacific">
        Australia/New Zealand/South Pacific
      </option>
    </select>

    <p htmlFor="reg_destination_3">What’s the #3 destination/region you sell?</p>
    <select id="reg_destination_3" name="reg_destination_3" onChange={props.change}>
      <option value="" disabled selected>
        Please select an option below
      </option>
      <option value="USA/Canada">USA/Canada</option>
      <option value="Mexico">Mexico</option>
      <option value="Caribbean">Caribbean</option>
      <option value="Central/South America/Antarctica">Central/South America/Antarctica</option>
      <option value="Europe">Europe</option>
      <option value="Africa/Middle East">Africa/Middle East</option>
      <option value="Asia">Asia</option>
      <option value="Australia/New Zealand/South Pacific">
        Australia/New Zealand/South Pacific
      </option>
    </select>

    <InputField
      change={props.change}
      fieldLabel="I am open to receiving additional email communications from the exhibitors whose booths I have visited during the show, and show sponsors"
      fieldName="marketing_opt_in"
      fieldType="checkbox"
      icon="clipboard-check"
      userSelect={false}
      line={false}
      title="I am open to receiving additional email communications from the exhibitors whose booths I have visited during the show, and show sponsors"
      defaultSelected
    />

    <div className="login__form--buttons">
      <button
        type="button"
        onClick={() => window.location.reload()}
        style={{ color: props.individualShowData ? props.individualShowData.primary_color : '' }}
        className="Email__input--button btnInverse"
      >
        {i18n.translate('general.back')}
      </button>
      <button
        type="submit"
        onClick={props.submit}
        className="Email__input--button"
        style={{
          backgroundColor: props.individualShowData ? props.individualShowData.primary_color : '',
        }}
      >
        {props.loadingAnimRegister ? (
          <span>
            <FontAwesomeIcon icon={['fas', 'circle-notch']} spin />
          </span>
        ) : (
          i18n.translate('loginScreen.register')
        )}
      </button>
    </div>
  </div>
);

export default RegisterTrade;

RegisterTrade.propTypes = {
  defaultVal: PropTypes.string,
  change: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  loadingAnimRegister: PropTypes.bool.isRequired,
};

RegisterTrade.defaultProps = {
  defaultVal: '',
};
